import React from 'react';
import GridRowContainer from 'shared/lib/extendedComponents/grids/components/gridRowContainer';
import DesktopSettingsCell from 'shared/lib/extendedComponents/grids/components/settingsCell/desktopSettingsCell';
import TextCell from 'shared/lib/extendedComponents/grids/components/textCell';
import ItemFormatCell from 'shared/lib/extendedComponents/grids/components/itemFormatCell';
import ItemSizeCell from 'shared/lib/extendedComponents/grids/components/itemSizeCell';
import { observer } from 'mobx-react-lite';
import DesktopFileNameCell from 'shared/lib/extendedComponents/grids/components/fileNameCell/desktopFileNameCell';
import MobileFileNameCell from 'shared/lib/extendedComponents/grids/components/fileNameCell/mobileFileNameCell';
import MobileSettingsCell from 'shared/lib/extendedComponents/grids/components/settingsCell/mobileSettingsCell';
import { getAbsPath } from 'app/api/api';
import { ExplorerEntityTypes, ContentFileItem } from 'entities/types';
import { useBooleanScreens } from 'shared/hooks/useBooleanScreens';
import { DateManager } from 'shared/lib/utils/dateManager';
import { noValue } from 'shared/lib/utils/uiConstants';

export default observer(function ContentFileRow({
  onClick,
  onFavorite,
  onEdit,
  onDownload,
  onRestore,
  onDelete,
  supportTypes,
  data,
}: {
  onClick?: () => void;
  onEdit?: () => void;
  onFavorite?: () => void;
  onDownload?: () => void;
  onRestore?: () => void;
  onDelete?: () => void;
  supportTypes: ExplorerEntityTypes[];
  data: ContentFileItem;
}) {
  const { isLessLaptop } = useBooleanScreens();

  return isLessLaptop ? (
    <GridRowContainer onClick={onClick}>
      <MobileFileNameCell
        name={data.name}
        preview={getAbsPath(data.preview_url) || null}
        size={data.size}
        updatedAt={data.last_change_date}
      ></MobileFileNameCell>
      <MobileSettingsCell
        onEdit={onEdit}
        onDownload={onDownload}
        onRestore={onRestore}
        onDelete={onDelete}
        onFavorite={onFavorite}
        isFavorite={data.is_favorite}
      ></MobileSettingsCell>
    </GridRowContainer>
  ) : (
    <GridRowContainer onClick={onClick}>
      <DesktopFileNameCell
        name={data.name}
        preview={getAbsPath(data.preview_url) || null}
        lastChangeAuthor={data.username}
      ></DesktopFileNameCell>
      <TextCell>{new DateManager(data.last_change_date).frontFormat}</TextCell>
      <ItemFormatCell format={data.extension}></ItemFormatCell>
      <ItemSizeCell size={data.size}></ItemSizeCell>
      <DesktopSettingsCell
        onEdit={onEdit}
        onDownload={onDownload}
        onRestore={onRestore}
        onDelete={onDelete}
        onFavorite={onFavorite}
        isFavorite={data.is_favorite}
      ></DesktopSettingsCell>
    </GridRowContainer>
  );
});
